import { render } from "./iconPicker.vue?vue&type=template&id=4f38836e&scoped=true"
import script from "./iconPicker.vue?vue&type=script&lang=js"
export * from "./iconPicker.vue?vue&type=script&lang=js"

import "./iconPicker.vue?vue&type=style&index=0&id=4f38836e&scoped=true&lang=css"
import "./iconPicker.vue?vue&type=style&index=1&id=4f38836e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f38836e"]])

export default __exports__